module.exports = __webpack_public_path__ + "static/media/arrow-right-black.c2d8bad9.svg";